import React from "react";

export const PublicContext = React.createContext({});
export const PublicProvider = PublicContext.Provider;
export const PublicConsumer = PublicContext.Consumer;
